import Filters from "./Pages/AdminConsole/Graph/Filters";

export const USER_SESSION_KEY = 'sankey-admin-user';
export const API_URL = '/api';
// true for just one graph, false to allow multiple
export const UNIQ_GRAPH = true;
export const GRAPH_HEIGHT = 600;

const GREEN_PALETTE = [
    "#128436",
];
const DARK_BLUE_PALETTE = [
    "#193E75",
];

const LILAC_PALETTE = [
    "#9D7EB8",
];

const WHALE_BLUE_PALETTE = [
    "#2A6AB2",
];

const SKY_BLUE_PALETTE = [
    "#83D0F5",
];

const TURQUOISE_PALETTE = [
    "#56BAA2",
];

const LIME_PALETTE = [
    "#BCCF00",
];

export const ALL_OPTIONS_COLUMN_NAME = 'C';

export const CANVAS_WIDTH = 1300;
export const CANVAS_HEIGHT = 600;

export const BASE_TEMPLATE = {
    filters: [
        {
            name: 'Tipo',
            type: Filters.NAMES.GRAPH_TYPE,
            options: [
                {
                    id: 0,
                    name: ALL_OPTIONS_COLUMN_NAME,
                    text: 'Todos'
                },
                {
                    id: 1,
                    name: 'Vehículos',
                    text: 'Vehículos'
                },
                {
                    id: 2,
                    name: 'Incentivos',
                    text: 'Incentivos'
                },
            ]
        },
        {
            name: 'Sector',
            type: Filters.NAMES.SECTOR,
            options: [
                {
                    id: 0,
                    name: ALL_OPTIONS_COLUMN_NAME,
                    text: 'Todos'
                },
                {
                    id: 1,
                    name: 'Público',
                    text: 'Público'
                },
                {
                    id: 2,
                    name: 'Privado',
                    text: 'Privado'
                },
                {
                    id: 3,
                    name: 'Cooperación',
                    text: 'Cooperación'
                }
            ]
        }
    ],
    groups: [
        {
            name: 'Fuentes de financiamiento',
            label: 'Fuentes de financiamiento',
            floating: false,
            weight: 0.28,
            subgroup: null,
            colors: GREEN_PALETTE,
            icon: 'png/Fuentes_Financiamiento.png',
            definition: 'Recursos fuentes fiscales: capta/genera recursos que se convierten en fuentes de financiamiento (capital), propiciando la movilización de recursos a actores del sistema económico que administran capital o a proyectos que viabilizan los recursos.'
        },
        {
            name: 'Administradores de recursos',
            label: 'Administradores de recursos',
            floating: false,
            weight: 0.16,
            subgroup: null,
            colors: WHALE_BLUE_PALETTE,
            icon: 'png/Administradores.png',
            definition: 'Administrador de recursos: gestionar y canalizar recursos, tanto públicos como privados, hacia proyectos y programas destinados a la protección y conservación de la biodiversidad.'
        },
        {
            name: '',
            floating: false,
            weight: 0.13,
            subgroup: [
                {
                    name: 'Incentivos con contraprestación monetaria',
                    label: 'Incentivos CON contraprestación monetaria',
                    floating: false,
                    weight: 0.13,
                    align: 'top',
                    colors: DARK_BLUE_PALETTE,
                    icon: 'png/Incentivos.png',
                    definition: 'Incentivo CON contraprestación monetaria: genera un cambio de comportamiento en los agentes económicos con transferencia de recursos bajo la normativa colombiana.'
                },
                    {
                    name: 'Incentivos sin contraprestación monetaria',
                    label: 'Incentivos SIN contraprestación monetaria',
                    floating: false,
                    weight: 0.13,
                    align: 'bottom',
                    colors: DARK_BLUE_PALETTE,
                    icon: 'png/Incentivos.png',
                    definition: 'Incentivo SIN contraprestación monetaria: genera un cambio de comportamiento en los agentes económicos sin transferencia de recursos bajo la normativa colombiana.'
                }
            ]
        },
        {
            name: 'Vehículos habilitados para ejecución de recursos',
            label: 'Vehículos habilitados para ejecución de recursos',
            floating: false,
            weight: 0.19,
            subgroup: null,
            colors: LILAC_PALETTE,
            icon: 'png/Vehiculo.png',
            definition: 'Vehículo habilitado para ejecución de recursos: instrumentos o mecanismos que permiten ejecutar recursos mediante proyectos.'
        },
        {
            name: 'Metas PAB',
            label: 'Metas PAB',
            floating: false,
            weight: 0.12,
            subgroup: null,
            colors: SKY_BLUE_PALETTE,
            definition: 'El Plan de Acción de Biodiversidad (PAB) de Colombia al 2030 establece 6 metas nacionales, para el cumplimiento de las 23 metas del Marco Global Kunming-Montreal, desde una visión estratégica que permite definir objetivos medibles, ambiciosos y alcanzables al 2030.',
            icon: 'png/Metas_PAB.png'
        },
        {
            name: 'Marco habilitante',
            label: 'Marco habilitante',
            floating: true,
            weight: 0.12,
            subgroup: null,
            colors: LIME_PALETTE,
            definition: 'Marco habilitante: marcos o estándares que no necesariamente tienen incentivos en la normativa colombiana, pero generan cambios de comportamiento voluntario.',
            icon: 'png/MarcoHabilitante.png',
        }
    ]
}

export const COLOR_PALETTES = {
    LINKS: ['#888888'],
    NODES:  [
        "#193E75", "#18476B", "#184E62", "#175758",
        "#16604E", "#156845", "#14713B", "#147A31",
        "#138327", "#128436"
    ]
};

export const STYLES = {
    NORMAL: {
        //FILL_COLOR: dynamic
        STROKE_COLOR: '#000',

        FONT_COLOR: '#000',
        FONT_SIZE: 12,
        FONT_WEIGHT: 'normal',

        // PATH COLOR: (dynamic)
        PATH_OPACITY: null
    },
    HIGHLIGHT: {
        FILL_COLOR: '#56BAA2',
        STROKE_COLOR: '#000',

        FONT_COLOR: '#000',
        FONT_SIZE: 12,
        FONT_WEIGHT: 'bold',

        PATH_COLOR: '#56BAA2',
        PATH_OPACITY: 0.8
    },
    GRAYSCALE: {
        FILL_COLOR: '#CCCCCC',
        STROKE_COLOR: '#CCCCCC',

        FONT_COLOR: '#464545ff',
        FONT_SIZE: 12,
        FONT_WEIGHT: 'normal',

        PATH_COLOR: '#CCCCCC',
        PATH_OPACITY: null
    }
}